import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { formatDate, getInitials } from '@/lib/utils';
import { Star } from 'lucide-react';

const DashboardReviewsTab = ({ reviews }) => {
    if (reviews.length === 0) {
        return (
            <Card className="rounded-2xl">
                <CardContent className="py-12 text-center">
                    <Star className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
                    <h3 className="font-semibold mb-2">Nu ai review-uri încă</h3>
                    <p className="text-muted-foreground">Review-urile vor apărea după finalizarea tranzacțiilor</p>
                </CardContent>
            </Card>
        );
    }

    return (
        <div className="space-y-4">
            {reviews.map(review => (
                <Card key={review.review_id} className="rounded-2xl">
                    <CardContent className="p-4">
                        <div className="flex items-start gap-4">
                            <Avatar>
                                <AvatarFallback>
                                    {getInitials(review.reviewer_name || review.reviewer_username)}
                                </AvatarFallback>
                            </Avatar>
                            <div className="flex-1">
                                <div className="flex items-center justify-between">
                                    <p className="font-semibold">{review.reviewer_name || review.reviewer_username}</p>
                                    <div className="flex items-center gap-1">
                                        {[1, 2, 3, 4, 5].map(star => (
                                            <Star
                                                key={star}
                                                className={`w-4 h-4 ${star <= review.rating ? 'text-yellow-500 fill-current' : 'text-gray-300'}`}
                                            />
                                        ))}
                                    </div>
                                </div>
                                <p className="text-sm text-muted-foreground mt-1">{review.comment}</p>
                                <p className="text-xs text-muted-foreground mt-2">
                                    {formatDate(review.created_at)}
                                </p>
                            </div>
                        </div>
                    </CardContent>
                </Card>
            ))}
        </div>
    );
};

export default DashboardReviewsTab;
